import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, Drawer as MobileDrawer, IconButton, List, Typography } from '@mui/material'
import {
  DashboardOutlined, PeopleOutlined, StorefrontOutlined,
  BarChartOutlined, ConfirmationNumberOutlined, Payment, LocalOfferOutlined, Menu, MailOutline, PersonAddAlt1Outlined,
} from '@mui/icons-material'
import { Container, Drawer, MenuItem } from 'components'
import UserIcon from 'components/Header/components/UserIcon'
import AccountMenuPopover from 'components/account/AccountMenuPopover'
import LogoSrc from 'components/Logo/Logo.png'
import LogoSmallSrc from 'components/Logo/LogoSmall.png'
import { useIsMobile } from 'utils/UI'

const tabs = [
  ['', 'Overview', DashboardOutlined],
  ['users', 'Users', PeopleOutlined],
  ['businesses', 'Businesses', StorefrontOutlined],
  ['offers', 'Offers', LocalOfferOutlined],
  ['credits', 'Credits', Payment],
  ['coupons', 'Coupons', ConfirmationNumberOutlined],
  ['reports', 'Reports', BarChartOutlined],
  ['notifications', 'Notifications', MailOutline],
  ['admission', 'Invitations', PersonAddAlt1Outlined],
]

export default function AdminLayout({ children }) {
  const mobile = useIsMobile()
  const { pathname } = useLocation()
  const user = useSelector(state => state.user.details || {})
  const [menuOpen, setMenuOpen] = useState(false)
  const [anchor, setAnchor] = useState(null)
  const section = pathname.split('/')[2] || ''
  const title = tabs.find(([path]) => path === section)?.[1] || 'Admin'
  const navigation = <Box width={300} component="nav" aria-label="Admin navigation">
    <Box pt={6} pb={4} display="flex" justifyContent="center">
      <Link to="/" aria-label="Home" onClick={() => setMenuOpen(false)}><img src={LogoSrc} alt="HiddenUnderGround" height={62} /></Link>
    </Box>
    <Typography variant="h6" fontSize={16} fontWeight={400} px={3} pb={2} color="text.secondary">Admin console</Typography>
    <List>{tabs.map(([path, label, Icon]) => <MenuItem key={path} icon={<Icon sx={{ color: 'black' }} />} text={label}
      link={`/admin${path ? `/${path}` : ''}`} end={!path} onClick={() => setMenuOpen(false)} />)}</List>
  </Box>

  return <Box sx={{ minHeight: '100vh', bgcolor: '#fcfcfc' }}>
    {mobile ? <MobileDrawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)}>{navigation}</MobileDrawer> : <Drawer>{navigation}</Drawer>}
    <Box component="main" sx={{ ml: mobile ? 0 : '300px', minHeight: '100vh' }}>
      <Box component="header"><Container><Box py={3} display="flex" alignItems="center" justifyContent="space-between" minHeight={48}>
        <Box display="flex" alignItems="center" gap={1}>
          {mobile && <Link to="/" aria-label="Home"><img src={LogoSmallSrc} alt="HiddenUnderGround" height={40} /></Link>}
          <Typography variant="h5">{title}</Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          {mobile && <IconButton aria-label="Open Admin navigation" onClick={() => setMenuOpen(true)}><Menu /></IconButton>}
          <UserIcon avatar={user.imageUrl} name={user.firstName || user.email || 'Account'} handleClick={e => setAnchor(e.currentTarget)} />
          <AccountMenuPopover anchorElement={anchor} onClose={() => setAnchor(null)} />
        </Box>
      </Box></Container></Box>
      <Container><Box pb={3}>{children}</Box></Container>
    </Box>
  </Box>
}
